module.exports = __webpack_public_path__ + "circle-uk.7e840c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/circle-uk.png
// module id = 923
// module chunks = 0